import React from 'react';
import { TCITooltip } from '@/components/ui/Tooltip';
import Text from '@/components/ui/Text';
import { VARIANT_STYLES, VERDICT_TOOLTIPS } from './AssessmentValidator.utils';

interface SummaryCardProps {
  count: number;
  label: string;
  variant: 'valid' | 'invalid' | 'incorrect' | 'vague';
}

export const SummaryCard = ({ count, label, variant }: SummaryCardProps) => (
  <TCITooltip>
    <TCITooltip.Trigger asChild>
      <div className={`tw-p-4 tw-rounded-lg tw-border tw-border-solid ${VARIANT_STYLES[variant]}`}>
        <Text size="lg" weight="bold">{count}</Text>
        <Text size="sm">{label}</Text>
      </div>
    </TCITooltip.Trigger>
    <TCITooltip.Content>
      {VERDICT_TOOLTIPS[variant]}
    </TCITooltip.Content>
  </TCITooltip>
);
